import React, { Component } from 'react';
import { connect } from 'react-redux';

import moment from 'moment';
import _ from 'lodash';

/* Actions */
import {
	getPerformanceData,
	savePerformanceData
} from '../../../redux/actions';

class Performance extends Component {

	constructor(props) {
		super(props);
		this.state = {
			errorMessage: '',
			performanceData: null,
			shortFormList: [{
				key: '350000',
				shortForm: '$350 k',
			}, {
				key: '600000',
				shortForm: '$600 k',
			}, {
				key: '800000',
				shortForm: '$800 k',
			}, {
				key: '1000000',
				shortForm: '$1.0 M',
			}, {
				key: '1500000',
				shortForm: '$1.5 M',
			}, {
				key: '2000000',
				shortForm: '$2.0 M',
			}, {
				key: '2500000',
				shortForm: '$2.5 M',
			}]
		};
		this.getShotForm = this.getShotForm.bind(this);
	}

	componentDidMount() {
		const self = this;
		const { performanceData } = self.props.state.resources;
		let dataByAccountNumber = performanceData && performanceData.find(item => item.accountNumber === self.props.getSelectedAccountNumber());
		dataByAccountNumber = dataByAccountNumber && dataByAccountNumber.data;
		if (!dataByAccountNumber) {
			self.props.getPerformanceData("requestType=pvrt&accountNumber="+self.props.getSelectedAccountNumber()+"&year=2025", response => {
				if (!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					});
				} else {
					self.props.savePerformanceData({
						accountNumber: self.props.getSelectedAccountNumber(),
						data: response
					});
					let data = JSON.parse(JSON.stringify(response.responseObject));
					data.guaranteedMatrix = window.convertToArrayOfObject(data.guaranteedMatrix, 'groupBy');
					data.growthMatrix = window.convertToArrayOfObject(data.growthMatrix, 'groupBy');
					self.setState({
						performanceData: data
					});
				}
			});
		} else {
			let data = JSON.parse(JSON.stringify(dataByAccountNumber.responseObject));
			data.guaranteedMatrix = window.convertToArrayOfObject(data.guaranteedMatrix, 'groupBy');
			data.growthMatrix = window.convertToArrayOfObject(data.growthMatrix, 'groupBy');
			self.setState({
				performanceData: data
			});
		}
		const { user } = this.props.state;
        if(user.selectedAccount && user.selectedPriceSource) {
            this.setState({
                showSelectAccountAndPriceSourceOverlayDialog: false
            });
        } else {
            this.setState({
                showSelectAccountAndPriceSourceOverlayDialog: true
            });
        }
	}

	getShotForm(key) {
		const self = this;
		const { shortFormList } = self.state;
		const data = shortFormList.find(item => item.key === key);
		return data ? data.shortForm : '';
	}

	checkIfHighlight(projectedVPercentage, currYearPayoutPer, value, growth) {
		if(growth === 'B') {
			value = value ? parseFloat(value) : value;
			if(projectedVPercentage < 10 && currYearPayoutPer === value) {
				return 'highlight-cell';
			}
		} else {
			value = value && value.list ? parseFloat(value.list) : value;
			if(growth === 10 && value === currYearPayoutPer && projectedVPercentage >= 10 && projectedVPercentage < 15) {
				return 'highlight-cell';
			} else if(growth === 15 && value === currYearPayoutPer && projectedVPercentage >= 15 && projectedVPercentage < 20) {
				return 'highlight-cell';
			} else if(growth === 20 && value === currYearPayoutPer && projectedVPercentage >= 20) {
				return 'highlight-cell';
			}
		}
		return null;
	}

	checkIfHighlightNew(vPercentage, targetGSB, growthMatrix, guaranteedMatrix) {
		if((growthMatrix && growthMatrix.length > 0) && (guaranteedMatrix && guaranteedMatrix.length > 0)) {
			const growthMatrixKeys = growthMatrix.map(growthMatrixKey => growthMatrixKey.key);
            const guaranteedMatrixKeys = guaranteedMatrix.map(guaranteedMatrixKey => guaranteedMatrixKey.key);
            const growthMatrixKeysFilter = growthMatrixKeys.filter((key) => key < targetGSB);
            growthMatrixKeysFilter && growthMatrixKeysFilter.length >= 1 ? growthMatrixKeysFilter.sort((a, b) => b - a) : '';
            const gsbValue = growthMatrixKeysFilter.length >= 1 ? growthMatrixKeysFilter[0] : '';
            let data = [];
            if(gsbValue) {
                if(guaranteedMatrixKeys.includes(gsbValue)) {
                    if(vPercentage >= 0 && vPercentage < 5) {
                        data = guaranteedMatrix.filter(val => val.key === gsbValue).find(val => val.list).list;
                    }
                }
                
                if(growthMatrixKeys.includes(gsbValue)) {
                    if(vPercentage >= 5 && vPercentage < 10) {
                        data = growthMatrix.filter(val => val.key === gsbValue).find(val => val.list).list[5];
                    } else if(vPercentage >= 10 && vPercentage < 15) {
                        data = growthMatrix.filter(val => val.key === gsbValue).find(val => val.list).list[10];
                    } else if(vPercentage >= 15) {
                        data = growthMatrix.filter(val => val.key === gsbValue).find(val => val.list).list[15];
                    }
                }
            }

            const result = {
                gsbValue,
                data
            }
    
            return result;
		}
		return null;
	}

	render() {
		const self = this;
		const { performanceData } = this.state;
		const { selectedAccount } = self.props.state.user;
		
		const result = performanceData && this.checkIfHighlightNew(performanceData.currentVPercentage, performanceData.targetGSB, performanceData.growthMatrix, performanceData.guaranteedMatrix);
		
		const priorYearGSB = performanceData && Math.round(performanceData.priorYearGSB);
		const priorYearGSB10Percent = performanceData && Math.round(performanceData.priorYearGSB + (performanceData.priorYearGSB) * 0.05);
		const priorYearGSB15Percent = performanceData && Math.round(performanceData.priorYearGSB + (performanceData.priorYearGSB) * 0.10);
		const priorYearGSB20Percent = performanceData && Math.round(performanceData.priorYearGSB + (performanceData.priorYearGSB) * 0.15);
		return (
			<div>
				<p className="red bold">{this.state.errorMessage}</p>
				{performanceData && performanceData.dataAvailable && <p style={{ float: 'right', display: 'inline-block' }}><a href="" onClick={this.props.handlePrint} className="withIcon withPrintIcon noUnderline uppercase bold">Print</a></p>}
				<h1 className="pageTitle" style={{ margin: '2em 0 1em' }}>Performance Volume Rebate Tracker</h1>
				{performanceData && !performanceData.dataAvailable && <p>No Performance Volume Rebate available for this account.</p>}
				{performanceData && performanceData.dataAvailable && <div>
					<b>Account:</b> {selectedAccount && selectedAccount.ACCOUNTNUMBER}&nbsp;<b>-</b>&nbsp;{selectedAccount && selectedAccount.ACCOUNTDESCRIPTION}<br />
					<h2>Today&#39;s Date: {moment().format('MMMM DD, YYYY')}</h2>
					<p className="orange" style={{ marginTop: '-14px' }}>(Billing Date: {performanceData.maxBillingDate})</p>
					<p style={{ marginBottom: 40 }}>The information in this screen is provided to those members that participate in the National PVR program. Information is updated weekly.</p>
					<h2>PVR Baseline &amp; Growth Targets</h2>
					<table cellPadding={0} cellSpacing={0} className="pvrTableOne push">
						<tbody>
							<tr>
								<th className="txt-ctr">
									Prior Year<br />
									Year-End Eligible<br />
									Count / Target <span style={{ fontWeight: 'normal' }}>(Baseline)</span>
								</th>
								<th className="txt-ctr">
									5% Growth<br />
									Target
									</th>
								<th className="txt-ctr">
									10% Growth<br />
									Target
									</th>
								<th className="txt-ctr">
									15% Growth<br />
									Target
									</th>
							</tr>
							<tr>
								<td className="txt-ctr"><b>{this.props.formatMoney(priorYearGSB.toFixed(0), 0, ".", ",", true, "$")}</b></td>
								<td className="txt-ctr">{this.props.formatMoney(priorYearGSB10Percent, 0, ".", ",", true, "$")}</td>
								<td className="txt-ctr">{this.props.formatMoney(priorYearGSB15Percent, 0, ".", ",", true, "$")}</td>
								<td className="txt-ctr">{this.props.formatMoney(priorYearGSB20Percent, 0, ".", ",", true, "$")}</td>
							</tr>
						</tbody>
					</table>
					<h2>Current PVR YTD As of {performanceData.maxBillingDate}</h2>
					<div style={{ width: 300, float: 'left', marginRight: 36 }}>
						<table className="dataTable">
							<caption className="txt-ctr">YTD Eligible Count / Target</caption>
							<thead>
								<tr>
									<th className="txt-ctr">GSB</th>
									<th className="txt-ctr">Current V%</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="txt-ctr" style={{ backgroundColor: '#fff' }}>{this.props.formatMoney(parseFloat(performanceData.targetGSB).toFixed(0), 0, ".", ",", true, "$")}</td>
									<td className="txt-ctr" style={{ backgroundColor: '#fff' }}>{performanceData.currentVPercentage}%</td>
								</tr>
								<tr>
									<td style={{ backgroundColor: '#eee', fontSize: '0.8em' }}>
										<b>Brands Eligible</b><br />
										Hotpoint<br />
										Haier<br />
										GE<br />
										Profile<br />
										Café<br />
										Monogram
									</td>
									<td style={{ backgroundColor: '#eee', fontSize: '0.8em' }}>
										<b>Product Types Eligible</b><br />
										Core Products<br />
										Closeouts(price class Y)<br />
										NetNet and EDV purchases<br />
										Cooktops<br />
										OTR and CMO Microwaves<br />
										Freezers<br />
										Compact Refrigeration<br/>
										Hoods<br/>
										Water Heater
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div style={{ width: 400, float: 'left', marginRight: 36 }}>
						<table className="dataTable" style={{ marginBottom: '0px' }}>
							<caption className="txt-ctr">YTD Eligible Purchases For Payout</caption>
							<thead>
								<tr>
									<th className="txt-ctr">GE, Haier</th>
									<th className="txt-ctr">Cafe, Profile</th>
									<th className="txt-ctr">Total Brands</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="txt-ctr" style={{ backgroundColor: '#fff' }}>{this.props.formatMoney(parseFloat(performanceData.gePayout).toFixed(0), 0, ".", ",", true, "$")}</td>
									<td className="txt-ctr" style={{ backgroundColor: '#fff' }}>{this.props.formatMoney(parseFloat(performanceData.cafeProfilePayout).toFixed(0), 0, ".", ",", true, "$")}</td>
									<td className="txt-ctr" style={{ backgroundColor: '#fff' }}>{this.props.formatMoney(parseFloat(performanceData.allBrandsPayout).toFixed(0), 0, ".", ",", true, "$")}</td>
								</tr>
								<tr style={{ backgroundColor: '#eee' }}>
									<td style={{ backgroundColor: '#eee', fontSize: '0.8em', padding: '10px' }}>
										<b>Brands Eligible</b><br />
										Haier<br />
										GE<br />
										Profile<br />
										Café
									</td>
									<td style={{ backgroundColor: '#eee', fontSize: '0.8em', padding: '10px' }}>
										<b>Product Types Eligible</b><br />
										Core Products<br />
										Cooktops<br />
										OTR Microwaves
									</td>
									<td />
								</tr>
							</tbody>
						</table>
					</div>
					<div style={{ width: 205, float: 'left' }}>
						<table className="dataTable">
							<caption className="txt-ctr">YTD</caption>
							<thead>
								<tr>
									<th>PVR Estimate</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="txt-ctr" style={{ backgroundColor: '#fff' }}>{this.props.formatMoney(parseFloat(performanceData.pvrEstimate).toFixed(0), 0, ".", ",", true, "$")}</td>
								</tr>
							</tbody>
						</table>
						<p className="orange push">Estimate includes flat PVR and Current Growth Bonus % PVR if applicable, includes DFI or Holdback</p>
					</div>
					<div className="clear" />
					<p className="orange push">Room Air products, accessories, parts, small appliances, and quotes are excluded from both target and payout eligibility.</p>
					<h2>YEAR END PROJECTED TARGET GSB AND ESTIMATED PVR</h2>
					<table cellPadding={0} cellSpacing={0} className="pvrTableOne">
						<tbody>
							<tr>
								<th className="txt-ctr">Annualized<br />Projected</th>
								<th className="txt-ctr">Projected<br />V%</th>
								{/* <th className="txt-ctr">Flat <br />Base</th> */}
								<th className="txt-ctr">GE, Haier <br />Growth Bonus</th>
								<th className="txt-ctr">Café, Profile <br /> Growth Bonus</th>
								<th className="txt-ctr">Total</th>
							</tr>
							<tr>
								<td className="txt-ctr"><b>{this.props.formatMoney(parseFloat(performanceData.annualProjected).toFixed(0), 0, ".", ",", true, "$")}</b></td>
								<td className="txt-ctr">{performanceData.projectedVPercentage.toFixed(2)}%</td>
								{/* <td className="txt-ctr">{this.props.formatMoney(parseFloat(performanceData.guaranteedBase).toFixed(0), 0, ".", ",", true, "$")}</td> */}
								<td className="txt-ctr">{this.props.formatMoney(parseFloat(performanceData.geGrowthBonus).toFixed(0), 0, ".", ",", true, "$")}</td>
								<td className="txt-ctr">{this.props.formatMoney(parseFloat(performanceData.cafeProfileGrowthBonus).toFixed(0), 0, ".", ",", true, "$")}</td>
								<td className="txt-ctr">{this.props.formatMoney(parseFloat(performanceData.totalProjectedTargetGSB).toFixed(0), 0, ".", ",", true, "$")}</td>
							</tr>
						</tbody>
					</table>
					<p className="orange push">Year-end PVR payout is an estimate only and is based on current purchases run rate, eligible for payout sales % and mix of sales by brands.</p>
					<h2>PVR Matrix</h2>
					<div className="captionAboveTable">
						<div style={{ float: 'right', width: '15%' }}>+15% Growth</div>
						<div style={{ float: 'right', width: '22%' }}>+10% Growth</div>
						<div style={{ float: 'right', width: '22%' }}>+5% Growth</div>
						<div style={{ float: 'right', width: '16%' }}>Flat</div>
						<div className="clear" />
					</div>
					<table className="dataTable" width="100%">
						<thead>
							<tr>
								<th style={{ fontSize: '0.9em' }} className="txt-ctr">
									PVR Target Retail<br />
									Purchases<br />
									($GSB)
								</th>
								<th style={{ fontSize: '0.9em' }} className="txt-ctr">
									GE, Haier<br />
									Café, Profile
								</th>
								<th style={{ fontSize: '0.9em' }} className="txt-ctr">GE<br />Haier</th>
								<th style={{ fontSize: '0.9em' }} className="txt-ctr">Café<br />Profile</th>
								<th style={{ fontSize: '0.9em' }} className="txt-ctr">GE<br />Haier</th>
								<th style={{ fontSize: '0.9em' }} className="txt-ctr">Café<br />Profile</th>
								<th style={{ fontSize: '0.9em' }} className="txt-ctr">GE<br />Haier</th>
								<th style={{ fontSize: '0.9em' }} className="txt-ctr">Café<br />Profile</th>
							</tr>
						</thead>
						<tbody>
							{performanceData.growthMatrix.map((item, index) => {
								const prepareOtherColumns = [];
								let key = 0;
								const guaranteedMatrixData = performanceData.guaranteedMatrix.find(itm => itm.key === item.key);
								prepareOtherColumns.push(<td className="txt-ctr" key={key++}>
									<span>
										{self.getShotForm(item.key)}
									</span>
								</td>);
								
								prepareOtherColumns.push(<td className="txt-ctr" key={key++}>
									<span className={(guaranteedMatrixData && result && item.key === result.gsbValue && result.data && result.data === guaranteedMatrixData.list) ? "highlight-cell" : ''}>
										{guaranteedMatrixData && `${parseFloat(guaranteedMatrixData.list).toFixed(2)}%`}
									</span>
								</td>);
								const growthData = window.convertToArrayOfObject(item.list, 'groupBy');
								growthData && growthData.length && growthData.forEach((it, ix) => {
																		
									prepareOtherColumns.push(<td className="txt-ctr" key={key++}>
										<span className={(it && result && item.key === result.gsbValue && result.data.length > 1 && result.data[0] === it.list[0]) ? "highlight-cell" : ''}>{parseFloat(it.list[0]).toFixed(2)}%</span>
									</td>);
									prepareOtherColumns.push(<td className="txt-ctr" key={key++}>
										<span className={(it && result && item.key === result.gsbValue && result.data.length > 1 && result.data[1] === it.list[1]) ? "highlight-cell" : ''}>{parseFloat(it.list[1]).toFixed(2)}%</span>
									</td>);
								});
								
									prepareOtherColumns[0] = (<td className="txt-ctr" key={key++}>
										<span className="txt-ctr">
											{self.getShotForm(item.key)}
										</span>
									</td>);

								return <tr key={index}>
									{prepareOtherColumns}
								</tr>
							})}
						</tbody>
					</table>
					<p className="orange push">Growth matrix rates are total payout and include base guarantee rate.</p>
				</div>}
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	return { state };
};

const mapDispatchToProps = (dispatch) => ({
	getPerformanceData: (queryStringParams, callback) => dispatch(getPerformanceData(queryStringParams, callback)),
	savePerformanceData: (data) => dispatch(savePerformanceData(data)),
});

Performance = connect(mapStateToProps, mapDispatchToProps)(Performance);
export default Performance;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Performance/index.js